import React from 'react';
// Modules
import { Container, VStack } from '@chakra-ui/react';
import { NextPage } from 'next/types';
// Components
import ComingSoon from '../components/general/ComingSoon';
import PageLoading from '../components/general/PageLoading';
import Page from '../components/layout/Page';
import Banner from '../components/promotion/Banner';
import MemberBenefits from '../components/promotion/MemberBenefits';
import PromotionList from '../components/promotion/PromotionList';
// Contexts
import { useAuth } from '../contexts/AuthContext';
// Firebase
import { useFeature } from '../firebase/client-helpers';
// Utils
import { FEATURES } from '../utils/constants';
import { isSuperAdmin } from '../utils/helpers';

const PromotionPage: NextPage = () => {
  const result = useFeature(FEATURES.PROMOTION);

  const { isLoading, role } = useAuth();

  function renderContent() {
    if (isLoading || result.loading) {
      return <PageLoading />;
    }

    if (isSuperAdmin(role) || result.data?.active) {
      return (
        <Container maxW="container.lg" p="4">
          <VStack alignItems="stretch" spacing="8">
            <Banner />
            <PromotionList />
            <MemberBenefits />
          </VStack>
        </Container>
      );
    }

    return <ComingSoon />;
  }

  return <Page>{renderContent()}</Page>;
};

export default PromotionPage;
